import {AB_TEST_HEADERS, getAbTestGroups} from '@aboutyou/feature-flags';
import {Request} from 'express';

export const getAbTestGroupsFromHeaders = (req: Request) => {
  const AYActiveABTestsHeader = req.header(AB_TEST_HEADERS.AYActiveABTests);

  return getAbTestGroups(AYActiveABTestsHeader);
};
